import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { campaign, onboardingHints } from '../../../constants';
import { ampliTrackMessageDisplayedEvent, MessageType } from '../../../services/track.service';
import { safeSessionStorage } from '../../../utils/safeStorage';
import { OnboardingHint } from '../../OnboardingHint';

interface RelatedTopicsHintProps {
	children: React.ReactNode;
}

const TRACKED_KEY = 'related-topics-hint-tracked';

// OnboardingHint calls onShow on every mount until the hint is dismissed, and the hint
// re-mounts many times per search (top + inline variant, scroll, tab switches). Track the
// analytics event at most once per app session so Amplitude isn't flooded. A single
// session-storage flag resets naturally on a new session/tab. The visual hint is independent
// of this and keeps showing across re-renders until the user dismisses it (localStorage).
const trackMessageDisplayedOncePerAppSession = () => {
	if (safeSessionStorage.getItem(TRACKED_KEY) === 'true') {
		return;
	}
	safeSessionStorage.setItem(TRACKED_KEY, 'true');
	ampliTrackMessageDisplayedEvent(campaign.relatedTopicsHint, MessageType.HINT);
};

const RelatedTopicsHint: React.FC<RelatedTopicsHintProps> = ({ children }) => {
	const { t } = useTranslation();

	return (
		<OnboardingHint
			id={onboardingHints.relatedTopics}
			title={t('Find faster what you need')}
			description={t('Tap a topic to refine your search. Filters stay active.')}
			placement="bottom-start"
			onShow={trackMessageDisplayedOncePerAppSession}
		>
			<Box>{children}</Box>
		</OnboardingHint>
	);
};

export default RelatedTopicsHint;
